import axios from 'axios'
import { axiosError } from './clientUtils'
import { getSubscriptionManagerApiBase } from './baseUrls'

const BASE_URL = getSubscriptionManagerApiBase()

function sleep(ms: number) { return new Promise(r => setTimeout(r, ms)) }

async function getWithRetry<T>(url: string, config = {}, retries = 2): Promise<T> {
  let attempt = 0
  let delay = 300
  while (true) {
    try {
      const res = await axios.get<T>(url, { ...config })
      return res.data
    } catch (err) {
      if (attempt >= retries) throw axiosError(err)
      await sleep(delay)
      delay *= 2
      attempt++
    }
  }
}

export interface InvoiceAddonResult {
  containsAddon: boolean
  invoiceNumber: string
  addonId: number
}

export async function checkInvoiceHasAccountingAddon(invoiceNumber: string): Promise<InvoiceAddonResult> {
  if (!invoiceNumber) throw new Error('invoiceNumber is required')
  const url = `${BASE_URL}/addons/invoice/${encodeURIComponent(invoiceNumber)}/contains/3`
  return getWithRetry<InvoiceAddonResult>(url)
}